import { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FetchReviewsContext } from '../providers/FetchReviewsProvider';
import { setReviewsFilters } from '../actions/reviewsFilters';
import { stateToSearchParams } from '../helpers';

export const useHistory = () => {
	const { page, reviewsFilters } = useSelector((state) => ({
		page: state.page,
		reviewsFilters: state.reviewsFilters
	}));
	const { fetchReviews } = useContext(FetchReviewsContext);
	const dispatch = useDispatch();

	// Updates the URL Search Params with the current state
	useEffect(() => {
		const searchParams = stateToSearchParams(reviewsFilters, {
			page
		});
		window.history.replaceState(
			{
				page,
				reviewsFilters
			},
			null,
			`?${searchParams.toString()}`
		);
		// we want to run this only for the first render
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// When the user clicks the back or next button, we want to update the state
	useEffect(() => {
		const handlePopState = async (history) => {
			dispatch(setReviewsFilters(history.state.reviewsFilters));
			await fetchReviews(
				history.state.page,
				history.state.reviewsFilters,
				false
			);
		};
		window.addEventListener('popstate', handlePopState);
		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
		// we want to run this only for the first render
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
